import { render, staticRenderFns } from "./sendQuestion.vue?vue&type=template&id=4a74f035"
import script from "./sendQuestion.vue?vue&type=script&lang=js"
export * from "./sendQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports